import { Data } from "@core/content/types";
import {
  createCreatorContentStore,
  toTargetNames as toTargetNamesCore,
} from "@core/content/creator/CreatorContentStore";
import type { CreatorPayload } from "@core/content/creator/types";

export const toTargetNames = toTargetNamesCore;

/** Pre-loaded artwork data injected by SSR (launch-v4). */
const injectedPayload: CreatorPayload | undefined =
  typeof window !== "undefined"
    ? (window as any).__ARTWORK_DATA__
    : undefined;

let manualContent: Data[] = [];

export let ContentData: Data[] = [...manualContent];
export let MicrositeData = { name: "", description: "", constructedCover: "" };
export let INITIAL_CONTENT_ID = "";
export let CreatorPayloadData: CreatorPayload | null = injectedPayload ?? null;

let creatorContentStore = createCreatorContentStore({ creatorDataSource: "", manualContent: [] });

export const configureCreatorContentStore = (options: {
  creatorDataSource: string;
  manualContent: Data[];
}): void => {
  manualContent = options.manualContent;
  ContentData = [...manualContent];
  MicrositeData = { name: "", description: "", constructedCover: "" };
  INITIAL_CONTENT_ID = "";
  CreatorPayloadData = injectedPayload ?? null;
  creatorContentStore = createCreatorContentStore({
    creatorDataSource: options.creatorDataSource,
    manualContent,
    injectedPayload,
  });
};

export const initializeCreatorData = async (): Promise<void> => {
  const state = await creatorContentStore.initialize();
  // Artwork names are prefixed with order ("01_Left", "02_Middle", "03_Right").
  // Sort so INITIAL_CONTENT_ID and the carousel both start from the left-most artwork.
  ContentData = [...state.contentData].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" })
  );
  MicrositeData = state.micrositeData;
  INITIAL_CONTENT_ID = ContentData.find((item) => item.type === "image")?.id
    ?? state.initialContentId;
  CreatorPayloadData = state.creatorPayload;
};

export const getContent = (id: string) => {
  return creatorContentStore.getContent(id);
};

export const getCreatorPayload = (): CreatorPayload | null => {
  return CreatorPayloadData;
};
